import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_image = _resolveComponent("input-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: "",
    style: _normalizeStyle(_ctx.imageSize)
  }, [
    _createVNode(_component_input_image, {
      "onUpdate:modelValue": _ctx.bannerImageUploaded,
      onImageCleared: _ctx.imageCleared,
      module: _ctx.DpModuleEnum.CMS,
      id: "banner-file-input",
      maxHeight: "75px",
      modelValue: _ctx.existingDocumentKey,
      typeCode: _ctx.docType,
      showFullSizePreviewOnHover: "",
      class: "preview-image"
    }, null, 8, ["onUpdate:modelValue", "onImageCleared", "module", "modelValue", "typeCode"])
  ], 4))
}